import React from "react";

import {
    StyledHeader,
    StyledSubTitle,
    StyledTitle,
} from "../../../styles/MainStyles";
import {
    StyledHeaderContainer,
    StyledTitleContent,
} from "../../../styles/pages/AdministratorTach/AdministratorTachStyles";
import GenerateTach from "../GenerateTach/GenerateTach";
import { useAdministratorTach } from "../../../context/AdministratorTachContext";

const HeaderTach = () => {
    const { isCreatedSubprocess } = useAdministratorTach();

    return (
        <StyledHeaderContainer>
            <StyledTitleContent>
                <StyledHeader>
                    <StyledTitle>Administrador TACH</StyledTitle>
                    <StyledSubTitle>
                        Aqui você pode gerar e justificar TACHs com pendências
                        de justificativa
                    </StyledSubTitle>
                </StyledHeader>
            </StyledTitleContent>
            {isCreatedSubprocess && <GenerateTach />}
        </StyledHeaderContainer>
    );
};

export default HeaderTach;
